import React, { Dispatch } from "react";
import "./InputForm.css"
interface InputFormProps  {
    value:string,
    setValue: Dispatch<React.SetStateAction<string>>,
    PrimaryText: string,
    SecondaryText: string,
    idInput: string,
    placeHolder:string,
    maxLength:number,
    valid:boolean,
    setValid: Dispatch<React.SetStateAction<boolean>>,
    notifChange?: () => void,
}


const InputForm:React.FC<InputFormProps> = ({value,setValue,PrimaryText,SecondaryText,placeHolder,maxLength,valid,setValid,notifChange}) => {

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValue(e.target.value)
        if(!valid) setValid(true)
        if(notifChange) notifChange()
    }

    return (
        <div className="containerInputForm">
            <p className="smallTextBold textInputForm" style={{color : valid ? "black" : "red",marginBottom:'5px', whiteSpace: valid ? 'nowrap':undefined}}>
                {   valid ?
                    PrimaryText : SecondaryText }
            </p>
            <div className='inputFormContainer' style={valid ? {} : {border: "1px solid red"} }>
                <input  type="text" className="smallText inputForm" value={value} onChange={handleChange} placeholder={placeHolder}  maxLength={maxLength} autoComplete="off"/>
            </div>
        </div>
    )
}

export default InputForm